module.exports = __webpack_public_path__ + "delete_video_icon.svg?b0f68ab8104883fc5f9c5aad754d23d8";


//////////////////
// WEBPACK FOOTER
// ./src/components/ApproveDashboard/Images/delete_video_icon.svg
// module id = 23
// module chunks = 20